import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BLUE, PURPLE, YELLOW } from 'govuk-colours';

var asAnchor = function asAnchor(AnchorType) {
  var Anchor = function Anchor(props) {
    return React.createElement(AnchorType, props, props.children);
  };

  Anchor.propTypes = process.env.NODE_ENV !== "production" ? {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    onClick: PropTypes.func,
    disabled: PropTypes.bool
  } : {};
  Anchor.defaultProps = {
    onClick: undefined,
    disabled: undefined
  };
  var StyledHoc = styled(Anchor)({
    color: BLUE,
    padding: '3px',
    margin: '-3px',
    outlineColor: 'transparent',
    display: 'inline-block',
    textDecoration: 'underline',
    ':focus': {
      backgroundColor: YELLOW,
      outline: "3px solid " + YELLOW
    },
    ':visited': {
      color: PURPLE
    }
  });
  return StyledHoc;
};

export default asAnchor;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/hoc/es/asAnchor/index.js
// module id = 66
// module chunks = 0